module.exports = __webpack_public_path__ + "img/savecar-logo.bf35044c.png";